import script from "./TheRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRadio.vue?vue&type=script&setup=true&lang=js"

import "./TheRadio.vue?vue&type=style&index=0&id=c64d1912&scoped=true&lang=css"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64d1912"]])

export default __exports__